function readFileAsync(file: File) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result as any);
    };

    reader.onerror = reject;

    reader.readAsArrayBuffer(file);
  });
}

export { readFileAsync };
